"use client";

import { useState, useEffect, useRef } from "react";

interface BodyProps {
	children: React.ReactNode;
	className?: string;
}

const SCROLL_OFFSET = 20;

export const Body: React.FC<BodyProps> = ({ children, className }) => {
	const [scrolledDown, setScrolledDown] = useState(false);
	const [scrolledUp, setScrolledUp] = useState(false);
	const lastScroll = useRef(0);

	useEffect(() => {
		lastScroll.current = window.scrollY;
		setScrolledDown(window.scrollY > SCROLL_OFFSET);

		const onScroll = () => {
			const currentScroll = window.scrollY;

			if (currentScroll > SCROLL_OFFSET) setScrolledDown(true);
			else setScrolledDown(false);

			if (currentScroll < lastScroll.current) setScrolledUp(true);
			else setScrolledUp(false);

			lastScroll.current = currentScroll;
		};

		window.addEventListener("scroll", onScroll);

		return () => {
			window.removeEventListener("scroll", onScroll);
		};
	}, []);

	return (
		<body data-scrolled-down={scrolledDown} data-scrolled-up={scrolledUp} className={className}>
			{children}
		</body>
	);
};
